export enum TankShape {
  VerticalCylinder = 'vertical-cylinder',
  HorizontalCylinder = 'horizontal-cylinder',
  HorizontalElliptical = 'horizontal-elliptical'
}
